import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'FINNCAL: Life on Your Terms | Portfolio & Freedom',
  description = "India's all-in-one personal finance platform. Track your portfolio, run X-Ray health checks, plan your financial freedom and grow family wealth.",
  url = 'https://finncal.com',
  image = 'https://finncal.com/og-image.png',
}) => {
  const fullTitle = title.includes('FINNCAL') ? title : `${title} | FINNCAL`;
  // Strip trailing slash (except bare domain) and query params so canonical is always clean
  const canonicalUrl = url.replace(/\?.*$/, '').replace(/(?<=.)\/+$/, '');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
